import moment from "moment";
import { LEGACY_INVOICE_PRICE, NEW_COURSE_PRICE } from "./coursePricing";

export const ATTORNEY_PRICE_EFFECTIVE_DATE = "2026-09-01";

export function getAttorneyInvoiceAmount(student) {
  // The API supplies the course's enrollment calendar date (YYYY-MM-DD).
  // Keep that date even if a timestamp is supplied; do not shift timezones.
  const date = String(student?.enrolDate ?? "").slice(0, 10);
  const validDate = moment(date, "YYYY-MM-DD", true).isValid();
  // Missing/invalid historical dates must not silently receive the new rate.
  return String(validDate && date >= ATTORNEY_PRICE_EFFECTIVE_DATE
    ? NEW_COURSE_PRICE
    : LEGACY_INVOICE_PRICE);
}

export function getAttorneyBulkInvoiceAmount(students, filter) {
  if (filter === "all") return String(NEW_COURSE_PRICE);

  const firstStudent = students.find((student) => student?.enrolDate);
  return firstStudent
    ? getAttorneyInvoiceAmount(firstStudent)
    : String(NEW_COURSE_PRICE);
}
